<template>
	<div
		id="app"
		:navigation-theme="navigation.theme"
		:style="styleLoaded ? '' : 'display:none'"
		:device-os="deviceOs"
		:scroll-position="scroll.position"
		:scroll-direction="scroll.direction"
		v-on:touchmove="checkAndSetItIsNoScreenReader()"
		v-on:mousemove="checkAndSetItIsNoScreenReader()"
	>
		<WrapperBody />
		<div id="BROWSER" style="display: none"></div>
		<div id="VERSION" style="display: none"></div>
		<input type="text" id="focusCatcher" aria-hidden="true" />
	</div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import { mutationTypes } from '@/types';
import WrapperBody from './wrapper/body.vue';

import { isIOS, mapStateNested } from '../tools/helpers';
import { logger } from '../tools/logger';

export default {
	name: 'App',
	components: {
		WrapperBody,
	},
	methods: {
		...mapMutations([mutationTypes.itIsNoScreenReader]),
		checkAndSetItIsNoScreenReader() {
			if (!this.$store.state.itIsNoScreenReader) {
				this.itIsNoScreenReader();
			}
		},
	},
	computed: {
		...mapState([
			'browserBarColor',
			'messages',
			'styleLoaded',
			'dataSourceCFG',
			'viewState',
			'navigation',
			'viewportSize',
			'viewportMode',
			'fontSize',
			'colorMode',
			'scroll',
		]),
		...mapStateNested('persistent', ['language']),
		...mapGetters([
			'globalConfig',
			'currentArticle',
			'currentExhibitionLanguageContent',
			'i18Notifyer',
			'currentLanguage',
		]),

		topButtonCount() {
			return this.navigation.top.length > 0;
		},
		bottomButtonCount() {
			return this.navigation.bottom.length > 0;
		},
		deviceOs() {
			return isIOS() ? 'iOS' : 'unknown';
		},
	},
	watch: {
		/**
		 * On viewport size changes the coresponding class small medium large xlarge on html attribute
		 */
		viewportSize(size) {
			document.getElementsByTagName('body')[0].setAttribute('view-size', size);
		},
		viewportMode(mode) {
			document.getElementsByTagName('html')[0].setAttribute('view-mode', mode);
		},
		fontSize(size) {
			document.getElementsByTagName('html')[0].setAttribute('font-size', size);
		},
		language(newLang) {
			document.getElementsByTagName('html')[0].setAttribute('lang', newLang);
		},
		colorMode(colorMode) {
			document.getElementsByTagName('html')[0].setAttribute('color-mode', colorMode);
		},
	},

	metaInfo() {
		const languages = this.globalConfig.languages
			? this.globalConfig.languages
					.map((lang) => `[hidden-in*='"${lang}":true']{display: none !important;}`)
					.join('\n')
			: '';
		return {
			// If no subcomponents specify a `metaInfo.title`, this title will be used
			// All titles will be injected into this template
			// titleTemplate: '%s',
			meta: [
				{ name: 'theme-color', content: this.browserBarColor },
				{ name: 'msapplication-navbutton-color', content: this.browserBarColor },
				{ name: 'apple-mobile-web-app-status-bar-style', content: this.browserBarColor },
			],
			style: [
				{
					cssText: `${languages}[hidden-in*='"${this.language}":true'] {opacity: .5;}`,
					type: 'text/css',
				},
			],
		};
	},
	beforeMount() {
		// Watcher to update i18n cause it is not accesible from the store.
		this.$store.watch(this.$store.getters.i18Notifyer, (newLang) => {
			this.$i18n.locale = newLang;
		});
		this.$i18n.locale = this.$store.state.persistent.language; // init i18n with the correct language
		// set viewport mode and size
		const html = document.getElementsByTagName('html')[0];
		html.setAttribute('font-size', this.fontSize);
		html.setAttribute('view-mode', this.viewportMode);
		html.setAttribute('color-mode', this.colorMode);
		html.setAttribute('lang', this.language);
		document.getElementsByTagName('body')[0].setAttribute('view-size', this.viewportSize);
		// check webClientID, create if not in session, FIXME, check if this is never called and delete
		if (!this.$store.state.persistent.webClientID) {
			logger.error('there is not webClientID :(');
			// this.$store.commit(mutationTypes.createWebclientID);
		}
	},
	beforeRouteLeave(to, from, next) {
		const answer = window.confirm('Do you really want to leave? you have unsaved changes!');
		if (answer) {
			next();
		} else {
			next(false);
		}
	},
};
</script>

<style lang="scss">
#focusCatcher {
	opacity: 0;
	height: 0;
	width: 0;
	width: 100px;
	border: 0;
	padding: 0;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 99999;
}
</style>
